module.exports = __webpack_public_path__ + "img/CheckCircle.086f03cc.png";